import { I18n } from '@calendly/i18n'

export const getEventLimitsSummary = (eventLimits) => {
  const { dailyLimit, weeklyLimit, monthlyLimit } = eventLimits || {}

  if (!dailyLimit && !weeklyLimit && !monthlyLimit) {
    return I18n.t('publisher.availability.host_meeting_limits.not_set')
  }

  const limits = []
  if (dailyLimit) {
    limits.push(I18n.t('publisher.availability.host_meeting_limits.daily', { count: dailyLimit }))
  }
  if (weeklyLimit) {
    limits.push(I18n.t('publisher.availability.host_meeting_limits.weekly', { count: weeklyLimit }))
  }
  if (monthlyLimit) {
    limits.push(I18n.t('publisher.availability.host_meeting_limits.monthly', { count: monthlyLimit }))
  }

  return limits.join(', ')
}
